/* eslint-disable react/jsx-curly-spacing */
import React, { Component } from "react";
import TablePelayanan from "./TablePelayanan.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import API from "../../apiService.js";
import { showLoading, toast } from "view/component/Alert.js";
import Select2 from "react-select";

class Pelayanan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      datas: [],
      filteredDatas: [],
      isLoading: true,
      clinic: [],
      frDate: JSON.parse(localStorage.getItem("SearchDate"))
        ? JSON.parse(localStorage.getItem("SearchDate")).date.frDate
        : moment(new Date()).format("YYYY-MM-DD"),
      enDate: JSON.parse(localStorage.getItem("SearchDate"))
        ? JSON.parse(localStorage.getItem("SearchDate")).date.enDate
        : moment(new Date()).format("YYYY-MM-DD"),
      keyword: {
        name: "",
        bod: "",
        nik: "",
        noRm: "",
        visitId: "",
        clinicId: JSON.parse(localStorage.getItem("SearchDate"))
          ? JSON.parse(localStorage.getItem("SearchDate")).clinic
          : JSON.parse(localStorage.getItem("userData"))
          ? JSON.parse(localStorage.getItem("userData")).clinic_id
          : "",
        clinic_multiple: [],
        continueId: "",
      },
      parent: false,
      limit: "10",
      sort: "ASC",
      served: false,
      puskesmas_id: JSON.parse(localStorage.getItem("puskesmasProfile"))
        ? JSON.parse(localStorage.getItem("puskesmasProfile")).code
        : "",
      cli_multi: null,
      rooms: [],
      selectedroom: null,
      allClinic: [],
    };

    this.handleChange = this.handleChange.bind(this);
    this.checkHandler = this.checkHandler.bind(this);
    this.checkHandlerrooms = this.checkHandlerrooms.bind(this);
  }

  onChangeKeyword = (e) => {
    const param = e.target.value;
    if (param > 0) {
      this.setState((prevState) => ({
        keyword: {
          // object that we want to update
          ...prevState.keyword, // keep all other key-value pairs
          noRm: param, // update the value of specific key
          name: "",
        },
      }));
    } else {
      this.setState((prevState) => ({
        keyword: {
          // object that we want to update
          ...prevState.keyword, // keep all other key-value pairs
          name: param, // update the value of specific key
          noRm: "",
        },
      }));
    }
    // console.log(this.state.keyword);
  };

  // checkHandler = (checked) => {
  //   let { datas } = this.state;
  //   if (checked) {
  //     this.setState({
  //       filteredDatas: datas,
  //     });
  //   } else {
  //     let dat = datas.data;
  //     let data = this.patientFilter(dat);
  //     this.setState((prevState) => ({
  //       filteredDatas: {
  //         // object that we want to update
  //         ...prevState.filteredDatas, // keep all other key-value pairs
  //         data: data,
  //       },
  //     }));
  //   }
  // };

  checkHandler = (checked) => {
    if (checked) {
      this.setState(
        {
          served: true,
        },
        () => this.fetchDatas()
      );
    } else {
      this.setState(
        {
          served: false,
        },
        () => this.fetchDatas()
      );
    }
  };

  checkHandlerrooms = (value) => {
    this.setState(
      {
        selectedroom: value,
      },
      () => {
        localStorage.setItem(
          "rooms",
          JSON.stringify({
            rooms: value,
          })
        );
        // console.log(this.state.selectedroom)
      }
    );
  };

  patientFilter = (data) => {
    if (!data) return [];
    return data.filter((value) => {
      return value.served === false;
    });
  };

  handleChange = (event) => {
    let id = event.target.value;
    let rooms = this.state.allClinic.find((e) => e.clinic_id == id);
    if (rooms) {
      if (rooms?.room?.length > 0) {
        this.setState({ rooms: rooms?.room ?? [] });
      } else {
        this.setState({ rooms: [] });
        this.checkHandlerrooms(null);
      }
    }
    let all = this.state.clinic.find((e) => e.clinic_id == id);
    let parent = all?.clinic?.child.length > 0 ? true : false;
    // console.log(all, parent)
    if (parent) {
      this.setState((prevState) => ({
        keyword: {
          // object that we want to update
          ...prevState.keyword, // keep all other key-value pairs
          clinicId: id, // update the value of specific key
        },
      }));
      this.setState({ parent: true });
    } else {
      this.setState((prevState) => ({
        keyword: {
          // object that we want to update
          ...prevState.keyword, // keep all other key-value pairs
          clinicId: id, // update the value of specific key
        },
      }));
      this.setState({ parent: false });
    }
  };

  componentDidMount() {
    this.fetchDatas();
    this.getClinic();
  }
  getClinic = async () => {
    const res = await API.get(
      "/apm/clinics/read/" + this.state.puskesmas_id + "/2/0"
    );
    if (res.code === 200) {
      localStorage.setItem("_ref_clinics_", JSON.stringify(res.data));
      this.setState(
        {
          clinic: res.data,
        },
        () => {
          const list_clinic = [];
          const all_clinic = [];

          this.state.clinic.map((clinic) => {
            if (clinic.clinic.child.length > 0) {
              clinic.clinic.child.map((cl) => {
                list_clinic.push({ id: cl.clinic_id, label: cl.name });
                all_clinic.push(cl);
              });
            } else {
              list_clinic.push({
                id: clinic.clinic.id,
                label: clinic.clinic.name,
              });
              all_clinic.push(clinic);
            }
          });
          this.setState({
            allClinic: all_clinic,
          });
          let sel = JSON.parse(localStorage.getItem("SearchDate"))
            ? JSON.parse(localStorage.getItem("SearchDate")).clinic
            : JSON.parse(localStorage.getItem("userData"))
            ? JSON.parse(localStorage.getItem("userData")).clinic_id
            : "";
          if (sel) {
            let cl = list_clinic.find((a) => a.id == sel);
            this.setState({
              cli_multi: {
                label: cl?.clinic?.name,
                value: cl?.clinic_id,
                disabled: false,
              },
            });
          }

          //rooms
          let clinic = JSON.parse(localStorage.getItem("SearchDate"))
            ? JSON.parse(localStorage.getItem("SearchDate")).clinic
            : JSON.parse(localStorage.getItem("userData"))
            ? JSON.parse(localStorage.getItem("userData")).clinic_id
            : "";
          let selected_room = JSON.parse(localStorage.getItem("rooms"))
            ? JSON.parse(localStorage.getItem("rooms")).rooms
            : null;

          let rooms = this.state.allClinic.find((e) => e.clinic_id == clinic);
          if (rooms) {
            this.setState({
              rooms: rooms?.room ?? [],
              selectedroom: selected_room,
            });
          }
        }
      );
    }
  };
  // fetchDatas = async () => {
  //   let param = {
  //     keyword: this.state.keyword,
  //     frDate: this.state.frDate,
  //     enDate: this.state.enDate,
  //     limit: this.state.limit,
  //     sort: this.state.sort,
  //     served: this.state.served,
  //   };

  //   const res = await API.post("registration", param);
  //   if (res.status === "success.") {
  //     this.setState({
  //       datas: res.data,
  //       isLoading: false,
  //     });
  //     localStorage.setItem('SearchDate', JSON.stringify({date :{frDate: this.state.frDate, enDate: this.state.enDate}}));
  //   } else {
  //     this.setState({
  //       datas: [],
  //       isLoading: false,
  //     });
  //   }
  // };
  fetchDatas = async () => {
    // console.log(this.state.cli_multi);
    let param = {
      keyword: this.state.keyword,
      frDate: this.state.frDate,
      enDate: this.state.enDate,
      limit: this.state.limit,
      sort: this.state.sort,
      served: this.state.served,
      parent: this.state.parent,
    };
    showLoading("Mencari Data");
    const res = await API.post("/registration/read", param);
    if (res.status === "success.") {
      toast({ status: "success", text: "Data Ditemukan" });
      this.setState({
        datas: res.data,
        isLoading: false,
      });
      localStorage.setItem(
        "SearchDate",
        JSON.stringify({
          date: { frDate: this.state.frDate, enDate: this.state.enDate },
          clinic: this.state.keyword.clinicId,
        })
      );
    } else {
      toast({ status: "error", text: "Data tidak ditemukan" });
      this.setState({
        datas: [],
        isLoading: false,
      });
    }
  };

  render() {
    const frDate = moment(this.state.frDate).toDate();
    const enDate = moment(this.state.enDate).toDate();
    const { filteredDatas, isLoading } = this.state;
    // console.log(this.state.clinic);
    const clinics = this.state.clinic.map((clinic, k) => {
      if (clinic.clinic.child.length > 0) {
        return (
          <optgroup key={`${clinic.clinic.id}-${k}`} label={clinic.clinic.name}>
            <option key={`${clinic.clinic.id}-${k}`} value={clinic.clinic.id}>
              {clinic.clinic.name} (semua klinik sub)
            </option>
            {clinic.clinic.child.map((cl, kk) => {
              return (
                <option key={`${cl.id}-${k}-${kk}`} value={cl.clinic_id}>
                  {cl.name}
                </option>
              );
            })}
          </optgroup>
        );
      } else {
        return (
          <option key={`${clinic.clinic.id}-${k}`} value={clinic.clinic.id}>
            {clinic.clinic.name}
          </option>
        );
      }
    });

    const list_clinic = [];
    this.state.clinic.map((clinic) => {
      if (clinic.clinic.child.length > 0) {
        clinic.clinic.child.map((cl) => {
          list_clinic.push({ id: cl.clinic_id, label: cl.name });
        });
      } else {
        list_clinic.push({ id: clinic.clinic.id, label: clinic.clinic.name });
      }
    });

    return (
      <div>
        <div className="container-fluid my-3">
          <div className="row">
            <div className="col">
              <div className="card">
                <div className="card-header border-0">
                  <div className="row">
                    <div className="col-md-2">
                      <h3>Kata Kunci</h3>
                    </div>

                    <input
                      className="form-control col-md-10"
                      name="katakunci"
                      placeholder="no RM/nama"
                      type="text"
                      onChange={this.onChangeKeyword}
                    />
                  </div>
                  <div className="row" style={{ marginTop: "2%" }}>
                    {/* klinik */}
                    <div className="col-md-2">
                      <h3>Klinik</h3>
                    </div>

                    <select
                      className="form-control col-md-2"
                      onChange={this.handleChange}
                      value={this.state.keyword.clinicId}
                    >
                      <option value="">Pilih Klinik</option>
                      {clinics}
                    </select>
                    {/* end_clinic */}
                    {/* <div className="col-md-2">
                      <h3>Klinik</h3>
                    </div>
                    <Select2
                      className="form-control col-md-2 p-0 pt-1"
                      styles={{
                        control: (styles) => ({
                          ...styles,
                          backgroundColor: "white",
                          border: "none",
                        }),
                      }}
                      value={this.state.cli_multi}
                      onChange={(e) =>
                        this.setState({ cli_multi: e })
                      }
                      isMulti
                      placeholder='Pilih klinik'
                      options={list_clinic.map((data) => ({
                        label: data.label,
                        value: data.id,
                        disabled: false,
                      }))}

                      isOptionDisabled={(option) => option.disabled}
                    /> */}

                    <div className="col-md-2">
                      <h3>Tanggal Kunjungan</h3>
                    </div>
                    <DatePicker
                      className="form-control col-md-12"
                      selected={frDate}
                      onChange={(date) =>
                        this.setState({
                          frDate: moment(date).format("YYYY-MM-DD"),
                        })
                      }
                      value={this.frDate}
                      dateFormat="yyyy-MM-dd"
                    />
                    <DatePicker
                      className="form-control col-md-12"
                      selected={enDate}
                      onChange={(date) =>
                        this.setState({
                          enDate: moment(date).format("YYYY-MM-DD"),
                        })
                      }
                      value={this.enDate}
                      dateFormat="yyyy-MM-dd"
                    />
                    <button
                      style={{ marginLeft: "2%" }}
                      className="btn btn-success"
                      onClick={this.fetchDatas}
                    >
                      CARI DATA
                    </button>
                  </div>
                  <div className="row mt-4">
                    <div className="col row">
                      <div className="custom-control custom-checkbox form-control-lg md-4">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          onChange={(e) => {
                            this.checkHandler(e.target.checked);
                          }}
                          id="exampleCheck1"
                          // checked = {this.state.served}
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="exampleCheck1"
                        >
                          tampilkan yang sudah dilayani
                        </label>
                      </div>
                      <h3 className="mt-3 ml-5">ruangan</h3>
                      {this.state.rooms.map((a) => (
                        <div
                          className="custom-control custom-radio ml-3"
                          key={`rooms-${a.id}`}
                        >
                          <input
                            name={`room-${a.id}`}
                            className="custom-control-input"
                            id={`room-${a.id}`}
                            type="radio"
                            value={a.clinic_room_name}
                            checked={this.state.selectedroom == a.clinic_room_name}
                            onChange={(e) =>
                              this.checkHandlerrooms(e.target.value)
                            }
                          />
                          <label
                            className="custom-control-label"
                            htmlFor={`room-${a.id}`}
                          >
                            {a.clinic_room_name}
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col">
              <div className="card">
                <TablePelayanan
                  headers={[
                    "No",
                    "Antrian",
                    "Klinik",
                    "Waktu",
                    "No MR",
                    "No Bpjs",
                    "NIK",
                    "Nama",
                    "Sex",
                    "tgl lahir",
                    "Aksi",
                  ]}
                  datas={this.state.datas}
                  isLoading={isLoading}
                  listsPerPage={10}
                  history={this.props.history}
                  keyword={{
                    keyword: this.state.keyword,
                    frDate: this.state.frDate,
                    enDate: this.state.enDate,
                    limit: this.state.limit,
                    sort: this.state.sort,
                    served: this.state.served,
                    parent: this.state.parent
                  }}
                  refClinic={this.state.clinic}
                  fetchDatas={this.fetchDatas}
                />
                <div className="card-footer">
                  <div className="mb-1">
                    <button
                      className="btn btn-sm"
                      style={{ backgroundColor: "#673ab7" }}
                    >
                      <i className="fas fa-check text-white"></i>
                    </button>{" "}
                    = Diabetes Mellitus
                  </div>
                  <div className="mb-1">
                    <button
                      className="btn btn-sm"
                      style={{ backgroundColor: "#df4af3" }}
                    >
                      <i className="fas fa-check text-white"></i>
                    </button>{" "}
                    = Hipertensi
                  </div>
                  <div>
                    <button
                      className="btn btn-sm"
                      style={{ backgroundColor: "#8bc34a" }}
                    >
                      <i className="fas fa-check text-white"></i>
                    </button>{" "}
                    = Diabetes Mellitus & Hipertensi
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Pelayanan;
